import React, { useState, useRef, useMemo } from 'react'
import MedicationTimePicker from './MedicationTimePicker';
import { medsCreateState, createMedsStep } from 'store/storeValtio';
import { timeToMinutes } from 'helpers/generalHelpers';
import ConfirmModal from 'components/common/ConfirmModal';
import parse from 'html-react-parser';

export default function MedicationSchedule({prevStep, nextStep}) {
  const [popup, setPopup] = useState(false);
  const [doseCount, setDoseCount] = useState(1);
  //console.log('MedSchedule', medsCreateState);

  const doseTimes = useRef(['']);
  const doses = useRef(1);

  useMemo(() => {
    let ndoses = medsCreateState.occurance;
    if ( medsCreateState.often === 'everyndays') ndoses = 1;
    if ( medsCreateState.often === 'weekly') {
      if (medsCreateState.schedule[0] === 'NotScheduled') ndoses = 1;
    }
    doses.current = ndoses;
    doseTimes.current = Array(ndoses).fill("");
  },[])

  function setTime(time) {
    //console.log('MS setTime', time, doseTimes.current);
    if (doseCount > 1) {
      let minutes0 = timeToMinutes(doseTimes.current[doseCount-2]);
      let minutes1 = timeToMinutes(time);
      //console.log('min', minutes0, minutes1);
      if (minutes0 >= minutes1) {
        setPopup(true);
        return;
      }
    }

    doseTimes.current[doseCount-1] = time;
    //console.log('counts', doses.current, doseCount);
    //console.log('times', doseTimes.current)
    if (doseCount < doses.current) {
      setDoseCount(doseCount + 1);
    } else {
      if (medsCreateState.often === 'weekly') {
        for (var i = 0; i < medsCreateState.schedule.length; ++i) {
          medsCreateState.schedule[i] =
            medsCreateState.schedule[i] + ';' + doseTimes.current[i];
        }
      } else {
        medsCreateState.schedule = doseTimes.current;
      }
      //medsCreateState.occurance = doses.current;
      nextStep(createMedsStep.confirm);
    }
  }

  let xd = doses.current;
  let xdc = doseCount;

  const whenText = ['zeroth','first','second','third','fourth','fifth','sixth'];
  let when = 'When do you take your medication?';
  if (doses.current > 1) {
    if (medsCreateState.often !== 'weekly') {
      when = 'When do you take your ' + whenText[doseCount] + ' dose?';
    }
    else {
      when = 'When do you take your <b>' + medsCreateState.schedule[doseCount-1] + '</b> dose?';
      xd = 3;
      xdc = 2;
    }
  }

  function popupClose() {
    setPopup(false);
  }

  return (
    <>
      <ConfirmModal 
        open={popup} 
        onCancel={()=>popupClose()}
        title='Time Entry Error'
        content='Selected time must be later that previous times'
        />
      <div className='medBody'>
        {parse(when)}
      </div>
      <MedicationTimePicker doseCount={xdc} doses={xd} setTime={setTime} /> 
    </>
  );
}
